import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Box } from "native-base";
import { useMemo } from "react";
import { useTranslation } from "@madmedical/i18n";
import ReactTable from "../molecules/ReactTable";
import ActionButton from "../molecules/ActionButton";
import Badge from "../atoms/Badge";
const RepresentativesTable = ({ data, onResendPress, onEditPress, onDeletePress, }) => {
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            Header: t("nameOrEmail"),
            defaultCanSort: true,
            accessor: "nameOrEmail",
        },
        {
            Header: t("comment"),
            defaultCanSort: true,
            accessor: "note",
            Cell: (props) => {
                const { note } = props.row.original;
                return _jsx(_Fragment, { children: note !== null && note !== void 0 ? note : "–" });
            },
            disableSortBy: true,
        },
        {
            Header: t("state"),
            defaultCanSort: true,
            accessor: "status",
            Cell: (props) => {
                const { status } = props.row.original;
                return (_jsx(Badge, Object.assign({ size: "sm", variant: `ghost${status ? "Success" : "Warning"}` }, { children: status ? t("active") : t("invited") })));
            },
        },
        {
            Header: "",
            id: "action",
            Cell: (props) => {
                const item = props.row.original;
                return (_jsx(Box, Object.assign({ flexDirection: "row", justifyContent: "flex-end", w: "full" }, { children: _jsx(ActionButton, { actions: [
                            ...(!item.status
                                ? [
                                    {
                                        text: t("resendEmail"),
                                        iconName: "mailAll",
                                        onPress: () => {
                                            onResendPress(item);
                                        },
                                    },
                                ]
                                : []),
                            {
                                text: t("edit"),
                                iconName: "edit",
                                onPress: () => {
                                    onEditPress(item);
                                },
                            },
                            {
                                text: t("delete"),
                                iconName: "trashCan",
                                onPress: () => {
                                    onDeletePress(item);
                                },
                            },
                        ] }) })));
            },
        },
    ], [onDeletePress, onEditPress, onResendPress, t]);
    return _jsx(ReactTable, { columns: columns, data: data });
};
export default RepresentativesTable;
